import React, { useEffect, useState } from "react";
import axiosInstance from "../config/axiosInstance";
import NoData from "../components/NoData";


const AdminAssinaturasPage = () => {
  const [assinaturas, setAssinaturas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAssinaturas = async () => {
      setLoading(true);
      try {
        const response = await axiosInstance.get("/subscriptions");
        setAssinaturas(response.data?.data || []);
        setError(null);
      } catch (err) {
        setError("Erro ao buscar assinaturas");
      } finally {
        setLoading(false);
      }
    };
    fetchAssinaturas();
  }, []);

  return (
    <div className="fade-in page-stack">
      <div className="page-header">
        <div>
          <h2>Assinaturas dos Anunciantes</h2>
          <p>Visualize todas as assinaturas realizadas na plataforma.</p>
        </div>
      </div>
      <div className="section-card">
        <h3 className="card-title">Assinaturas cadastradas</h3>
        {loading ? (
          <div className="muted">Carregando assinaturas...</div>
        ) : error ? (
          <div className="alert">{error}</div>
        ) : assinaturas.length === 0 ? (
          <NoData title="Nenhuma assinatura encontrada" description="Nenhum anunciante realizou assinatura ainda." />
        ) : (
          <table className="table">
            <thead>
              <tr>
                <th>Empresa</th>
                <th>Plano</th>
                <th>Limite de Produtos</th>
                <th>Preço</th>
                <th>Status</th>
                <th>Início</th>
                <th>Expira em</th>
              </tr>
            </thead>
            <tbody>
              {assinaturas.map((a) => (
                <tr key={a.id}>
                  <td>{a.company?.nomeFantasia || a.companyId}</td>
                  <td>{a.plan}</td>
                  <td>{a.productsLimit}</td>
                  <td>R$ {Number(a.price).toLocaleString("pt-BR", { minimumFractionDigits: 2 })}</td>
                  <td>{a.status}</td>
                  <td>{a.startedAt ? new Date(a.startedAt).toLocaleDateString() : "-"}</td>
                  <td>{a.expiresAt ? new Date(a.expiresAt).toLocaleDateString() : "-"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
};

export default AdminAssinaturasPage;
